
import { useEffect, useState } from 'react'
import './meetingdetails.css'
import Hexapi from '../../utility/HexAPI/Hexapi'
import Header from './Header'
import Loader from '../../components/loader/Loader'
import Detailssection from './Detailssection'

const Meetingdetails = ({meetingid,userid}) => {

    const[loading,setLoading] = useState(false)
    const [meetingAction,setmeetingAction] = useState([])
    const [meetingInfo,setmeetingInfo] = useState(null)
    const [open, setOpen] = useState(false);
    const[details,setDetails] = useState(null)
const getMeetingDetails = async () => {
    const obj = {
        query:`HRApp_Droid_Proc_User_Meeting_Information_GetValueV2 @MeetingID='{0}',@UserID='{1}'`,
        queryArr:[`${meetingid}`,`${userid}`]
    }
    try {
        setLoading(true)
        const resp = await Hexapi(obj,()=>getMeetingDetails(),1,0,meetingid)
        const data = resp && resp[""] ? resp[""] : [];
console.log("Meeting Details Response:", resp)
        if(resp && resp.meetinginfo && resp.meetinginfo.length > 0){
            setmeetingInfo(resp.meetinginfo[0])
        }else{
            setmeetingInfo(null)
        }

        if(resp && resp.meetingactions && resp.meetingactions.length > 0){
            setmeetingAction(resp.meetingactions)
        }else{
            setmeetingAction([])
        }
        setDetails(data[0])
    } catch (error) {
        console.error("Meeting Details Error:", error);
    } finally {
        setLoading(false)
    }
}

useEffect(()=>{
    if(meetingid && userid){
        getMeetingDetails()
    }
},[meetingid,userid])
  return (
    <div className='meetingdetails'>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
                <Loader />
              </div>
      ) : details ? (

        <div className='meetingdetailinfo' style={{ position: "relative" }}>
            <Header info={meetingInfo}  onClick={() => setOpen(true)}/>
                {
                    meetingAction && meetingAction.length > 0 && <Detailssection userID={userid} meetingInfo={meetingInfo} details={meetingAction}/>
                }
            
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center"
  style={{ height: "78vh", color: "#ff6d00" }}>
  No Meeting Details Available
</div>
      )}

      {/* <Meetinginfo
  open={open}
  onClose={() => setOpen(false)}
  info={meetingInfo}
/> */}
    </div>

  )
}
export default Meetingdetails